<template>
  <div class="home">
    <vue-headful title="网站地图 - ITT流体技术" description="ITT流体技术网站地图" />
    <div class="container">
      <div class="header">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <h2 class="page-title">网站地图</h2>

      <div class="sitemap-section">
        <h3 class="section-title">导航页面</h3>
        <ul class="sitemap-links">
          <li><a href="#/">首页</a></li>
          <li><a href="#/search">产品搜索</a></li>
          <li><a href="#/brands">品牌列表</a></li>
          <li><a href="#/download">下载查询</a></li>
          <li><a href="#/contact">联系我们</a></li>
          <li><a href="#/tools">工具</a></li>
          <li><a href="#/valve">阀门查询</a></li>
          <li><a href="#/main">主站</a></li>
        </ul>
      </div>

      <div class="sitemap-section">
        <h3 class="section-title">品牌</h3>
        <div v-if="loading" class="loading">加载中...</div>
        <ul class="sitemap-links" v-else>
          <li v-for="brand in brands" :key="brand.id">
            <a v-if="brand.blocks_count > 0" :href="'#/brands/' + brand.id">{{ brand.name }}</a>
            <span v-else class="disabled-link">{{ brand.name }}</span>
          </li>
        </ul>
      </div>

      <div class="sitemap-section">
        <h3 class="section-title">应用领域</h3>
        <div v-if="loading" class="loading">加载中...</div>
        <ul class="sitemap-links" v-else>
          <li v-for="app in applications" :key="app.id">
            <a :href="'#/applications/' + app.id">{{ app.name }}</a>
          </li>
        </ul>
      </div>

      <div class="sitemap-section">
        <h3 class="section-title">用户服务</h3>
        <ul class="sitemap-links">
          <li><a href="#/form">在线留言</a></li>
          <li><a href="#/device-reg">设备注册</a></li>
          <li><a href="#/reg">用户注册</a></li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
    </div>
  </div>
</template>

<script>
import { getBrands, getApplications } from "@/api/request";

export default {
  name: "sitemap",
  data() {
    return {
      brands: [],
      applications: [],
      loading: true,
    };
  },
  async mounted() {
    try {
      const [brandsRes, appsRes] = await Promise.all([getBrands(), getApplications()]);
      this.brands = brandsRes.data || [];
      this.applications = appsRes.data || [];
    } catch (e) {
      console.error("Failed to load sitemap data", e);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  padding-bottom: 30px;
  min-height: calc(100vh - 221px);

  .header {
    margin: 20px 10px;
    height: 15px;
    background-color: #1d4f48;
    display: flex;
    .left {
      flex: 1 0 62.4%;
    }
    .right {
      flex: 1 0 37.6%;
      background-color: #ccc;
    }
  }

  .page-title {
    color: #1d4f48;
    font-size: 1.2rem;
    padding: 10px 15px;
    margin: 0;
    border-bottom: 2px solid #1d4f48;
  }

  .sitemap-section {
    padding: 0 15px;
    margin-top: 20px;

    .section-title {
      color: #1d4f48;
      font-size: 1rem;
      margin: 0 0 10px 0;
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
    }
  }

  .sitemap-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 50%;
      box-sizing: border-box;
      padding: 6px 10px 6px 0;

      a {
        color: #535353;
        text-decoration: none;
        font-size: 0.85rem;
        display: inline-block;

        &:active {
          color: #1d4f48;
        }
      }

      .disabled-link {
        color: #999;
        font-size: 0.85rem;
      }
    }
  }

  .loading {
    color: #999;
    font-size: 0.85rem;
    padding: 10px 0;
  }
}
</style>
